import ImageGridViewer from "./ImageGridViewer";
import { useStore } from 'react-redux';
import { useState } from 'react';
import G from './Getters';

export default function MicroscopyExperimentViewer({_id}){

  const store = useStore();
  const state = store.getState();

  const rec = G.getRecord(state, { _id });
  console.log(rec);
  let {ndImageArray, order} = rec.data.multidim;
  const [permOrder, setPermOrder] = useState(order); // ['T', 'Z', 'C']);
  return <>
    {/*<O>{G.listDirectory(state, { _id: 'hyper' })}</O>
    <O>{G.listDirectory(state, { _id: 'v_t=dir;parent=hyper;idxs=T:0' })}</O>
    <O>{G.listDirectory(state, { _id: 'v_t=dir;parent=hyper;idxs=T:0,Z:0' })}</O>
    <O>{G.getDirectoryNdarray(state, { _id: 'hyper' })}</O>*/}
    <ImageGridViewer imageArray={ndImageArray} order={order} permOrder={permOrder} setPermOrder={setPermOrder}/>
  </>;


}
